import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Floor = () => {
  const { t, updateAddress, errors, floor, isApartment, showFloor, showAddressFields } = useAddress()

  if (!showFloor || !showAddressFields || !isApartment) {
    return null
  }

  return (
    <FormControl error={getError('floor', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.floor')}
        onBlur={floor => updateAddress({ floor })}
        currentValue={floor}
      />
    </FormControl>
  )
}

export default Floor
